<script>
export default {
    props: {
        valid: {
            type: Object,
            default: () => []
        }
    }
}
</script>

<template>
    <label :for="$attrs.for" class="text-sm leading-5 font-medium text-bhav-blue-300 border-t border-t-oakwood-gray-100 py-4" :class="{'text-oakwood-red' : valid.length}">{{ $attrs.label }}</label>
    <div class="text-sm leading-5 text-oakwood-gray-900 lg:col-span-3 lg:border-t border-t-oakwood-gray-100 py-4 flex gap-4 items-end">
        <slot></slot>
        <ul v-if="valid.length" class="text-oakwood-red">
            <li v-for="error,i in valid" :key="`error-${i}`">{{ error }}</li>
        </ul>
    </div>
</template>
